import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M18.62 2v2m-12-2v2"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M12.615 13h.009m-.01 4h.01m3.986-4h.01m-8 0h.008m-.009 4h.01"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M4.12 8h17M3.12 12.243c0-4.357 0-6.536 1.251-7.89C5.623 3 7.64 3 11.67 3h1.9c4.03 0 6.046 0 7.298 1.354 1.252 1.353 1.252 3.532 1.252 7.89v.513c0 4.357 0 6.536-1.252 7.89C19.615 22 17.6 22 13.569 22h-1.9c-4.03 0-6.046 0-7.298-1.354-1.252-1.353-1.252-3.532-1.252-7.89zM3.62 8h18"
    }, null, -1)
  ])))
}
export default { render: render }